import { getCookie } from '@/utils/cookie'
import Url from '@mc/mc-utils/js/url/url'

const getFromUrl = () => {
  const url = new Url(window.location.href)
  const { open_id: openId } = url.parseQuerystring()
  return openId
}

export const getOpenId = () => getFromUrl() || getCookie('utoken')
